import React, { useState } from 'react';
import { Button, Form } from "react-bootstrap";
import { CartState } from '../context/Context';
import { productReducer } from '../context/Reducers';
import Rating from './Rating';

const Filters = () => {
    

    const {
      productState:{byStock, byFastDelivery, sort, byRating},
      productDispatch,
     } = CartState();

  return(
   <div className='filters'>
       <h3 className='title2'>Filter Items</h3>
       
       <span>
       <br />
       <span>Price:</span><br />
           <Form.Check
                inline
                label="LowToHigh"
                name="group1"
                type="radio"
                id={`inline-1`}
                onChange={() =>
                    productDispatch({
                      type: "SORT_BY_PRICE",
                      payload: "lowToHigh",
                    })
                  }
                  checked={sort === "lowToHigh" ? true : false}
           />
       </span>
       <span>
            <Form.Check
                inline
                label="HighToLow"
                name="group1"
                type="radio"
                id={`inline-2`}
                onChange={() =>
                    productDispatch({
                      type: "SORT_BY_PRICE",
                      payload: "highToLow",
                    })
                  }
                  checked={sort === "highToLow" ? true : false}
            />
       </span>
       
       <span>
       <br />
            <Form.Check
                inline
                label="Include Out of Stock"
                name="group1"
                type="checkbox"
                id={`inline-3`}
                onChange={() =>
                  productDispatch({
                    type: "FILTER_BY_STOCK",
                  })
                }
                checked={byStock}
            />
       </span>
       <span>
            <Form.Check
                inline
                label="Fast Delivery Only"
                name="group1"
                type="checkbox"
                id={`inline-4`}
                onChange={() =>
                  productDispatch({
                    type: "FILTER_BY_DELIVERY",
                  })
                }
                checked={byFastDelivery}
            />
       </span>
       
       <span>
       <br/>
           <label style={{ paddingRight: 10}}>Rating: </label>
           <Rating 
                rating={byRating} 
                onClick={(i)=> 
                    productDispatch({
                        type: "FILTER_BY_RATING",
                        payload: i + 1,
                      })
                }
                style={{ cursor:"pointer" }} 
            />
       </span>
       <Button  variant='light' onClick={() =>
          productDispatch({
            type: "CLEAR_FILTERS",
          })
        }>Remove All Filters</Button>
   </div>
  );
};

export default Filters;
